import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-649983d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "app-loader"
}
const _hoisted_2 = { class: "app-loader__inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon icon-spinner" })
], -1))
const _hoisted_4 = {
  key: 0,
  class: "app-loader__message"
}
const _hoisted_5 = {
  key: 1,
  class: "d-app-loader"
}
const _hoisted_6 = { class: "d-app-loader__inner" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon icon-spinner" })
], -1))
const _hoisted_8 = {
  key: 0,
  class: "app-loader__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          (_ctx.message.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.message), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          (_ctx.message.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.message), 1))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ]))
}